import { jsx } from "react/jsx-runtime";
import { forwardRef, useMemo } from "react";
import { cn as clsx } from "./helpers/react.js";
import { InputFieldContext } from "./components/InputFields/InputField/InputFieldContext.js";
import './assets/GenericRoot.css';const container = "_container_1v9ks_1";
const error = "_error_1v9ks_27";
const disabled = "_disabled_1v9ks_35";
const inline = "_inline_1v9ks_42";
const iconDisabled = "_iconDisabled_1v9ks_60";
const combobox = "_combobox_1v9ks_76";
const input = "_input_1v9ks_87";
const button = "_button_1v9ks_91";
const comboboxInputSection = "_comboboxInputSection_1v9ks_130";
const suffix = "_suffix_1v9ks_131";
const leftIcon = "_leftIcon_1v9ks_149";
const comboboxInputSectionIcon = "_comboboxInputSectionIcon_1v9ks_153";
const rightIcon = "_rightIcon_1v9ks_154";
const buttonContent = "_buttonContent_1v9ks_158";
const fill = "_fill_1v9ks_174";
const s = {
  container,
  "default": "_default_1v9ks_22",
  error,
  disabled,
  inline,
  iconDisabled,
  combobox,
  input,
  button,
  comboboxInputSection,
  suffix,
  leftIcon,
  comboboxInputSectionIcon,
  rightIcon,
  buttonContent,
  fill
};
const _GenericRoot = forwardRef(
  ({ className, children, label, disabled: disabled2, inline: inline2, errorState, fill: fill2, iconDisabledState, as, ...rest }, ref) => {
    const Component = as;
    const contextValue = useMemo(() => ({ disabled: disabled2 }), [disabled2]);
    return /* @__PURE__ */ jsx(
      Component,
      {
        ...rest,
        className: clsx(
          s.container,
          inline2 ? s.inline : s.default,
          {
            [s.disabled]: disabled2,
            [s.fill]: fill2,
            [s.error]: !disabled2 && errorState,
            [s.iconDisabled]: !disabled2 && iconDisabledState
          },
          className
        ),
        ref,
        type: "button",
        children: /* @__PURE__ */ jsx(InputFieldContext.Provider, { value: contextValue, children })
      }
    );
  }
);
export {
  _GenericRoot as _,
  s
};
